import last from 'lodash/last';
import { TRAVELMODE_DONE } from 'utils/directions/constants';
import { SNAP_CLOSE } from 'utils/getSnap';
import Leg from './Leg';
import splice from './splice';

function routing(route, action) {
  const { legs } = action;
  let { routes } = action;
  // Check for snapped points
  const legIndexes = route.get('legs');
  let index = legIndexes.indexOf(legs[0].id);
  const legAfter = route.get(legIndexes.get(index + routes.length));
  if (legAfter) {
    const pointsAfter = checkLegAfter(legAfter, last(last(routes)));
    if (pointsAfter) {
      routes = [...routes, pointsAfter];
    }
  }
  const legBefore = route.get(legIndexes.get(index - 1));
  if (legBefore) {
    const pointsBefore = checkLegBefore(legBefore, routes[0][0]);
    if (pointsBefore) {
      index--;
      routes = [pointsBefore, ...routes];
    }
  }
  const newLegs = routes.map(points => new Leg(points, TRAVELMODE_DONE));
  const params = [route, index, newLegs.length, ...newLegs];
  return splice(...params);
}

function checkLegAfter(leg, point) {
  const snapPoint = leg.points[0];
  if (snapPoint.snap && snapPoint.snap.status === SNAP_CLOSE) {
    return [point, ...leg.points.slice(1)];
  }
  return null;
}

function checkLegBefore(leg, point) {
  const snapPoint = leg.lastPoint;
  if (snapPoint.snap && snapPoint.snap.status === SNAP_CLOSE) {
    return [...leg.points.slice(0, -1), point];
  }
  return null;
}

export default routing;
